import React, { useState } from "react";
import { css } from "@emotion/react";
import Backdrop from "@material-ui/core/Backdrop";
import { makeStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";
import './loader.css'

const useStyles = makeStyles((theme) => ({
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: "#fff",
    },
}));
// Can be a string as well. Need to ensure each key-value pair ends with ;
const override = css`
	display: block;
	margin: 0 auto;
	border-color: #4caf50;
	position: relative;
	left: 0px;
	top: 0px;
	width: 0px;
	height: 0px;
	z-index: 9999;
	background: rgba(255, 255, 255, 0.6);
`;
function LoaderComponent(props) {
    const { isLoaderShow } = props
    const classes = useStyles();
    let [loading] = useState("true");
    return (
        <div className="sweet-loading" style={{ zIndex: "99999" }}>
            <Backdrop className={classes.backdrop} open={isLoaderShow}>
                <div>
                    {/* <div className="logo">
                        <img width="128" src="assets/images/logos/fuse.svg" alt="logo" loading={loading} css={override} />
                    </div> */}
                    <div className="spinner-wrapper">
                        <div className="spinner">
                            <div className="inner">
                                <div className="gap"></div>
                                <div className="left">
                                    <div className="half-circle"></div>
                                </div>
                                <div className="right">
                                    <div className="half-circle"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Backdrop>
        </div>
    );
}

const mapStateToProps = state => {
    return {
        isLoaderShow: state.fuse.loader.isLoaderShow
    }
}


export default connect(mapStateToProps, '')(LoaderComponent)
